document.addEventListener('DOMContentLoaded', function () {
  const slides = document.querySelectorAll('.slider-item');

  let currentSlide = 0;
  const totalSlides = slides.length;
  const slideChangeInterval = 5000;

  function showSlide(index) {

    // Hide all slides
    slides.forEach((slide) => {
      slide.style.display = 'none';
    });

    // Show the current slide if index is within range
    if (index >= 0 && index < totalSlides) {
      slides[index].style.display = 'block';
    } else {
      console.warn('Index out of bounds:', index);
    }
  }

  // Show the first slide initially
  showSlide(currentSlide);

  // Loop through on the defined interval
  setInterval(function () {
    currentSlide = (currentSlide < totalSlides - 1) ? currentSlide + 1 : 0;
    showSlide(currentSlide);
  }, slideChangeInterval);
});
